import request from '@/api/request'

export default {
  async getColors () {
    return (await request.get(`module/action/marketplace/renner/color`)).data
  },
  async getSizes () {
    return (await request.get(`module/action/marketplace/renner/size`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/renner/index.js